/* Selector file rule: root-level functions in this file must be exported selectors only. Move helper functions to lib files. */
import * as uiSelectors from '@/redux/selectors/uiSelectors.js';
import * as userSelectors from '@/redux/selectors/userSelectors.js';
import * as baseSelectors from '@/redux/selectors/pieveSelectors/baseSelectors.js';
import * as sidebarChromeSelectors from '@/redux/selectors/pieveSelectors/sidebarChromeSelectors.js';
import * as sidebarSkillSelectors from '@/redux/selectors/pieveSelectors/sidebarSkillSelectors.js';
import * as sidebarProjectSelectors from '@/redux/selectors/pieveSelectors/sidebarProjectSelectors.js';
import * as sidebarThreadCollectionSelectors from '@/redux/selectors/pieveSelectors/sidebarThreadCollectionSelectors.js';
import * as sidebarOrganizationSelectors from '@/redux/selectors/pieveSelectors/sidebarOrganizationSelectors.js';
import * as sidebarSearchSelectors from '@/redux/selectors/pieveSelectors/sidebarSearchSelectors.js';
import * as routeSelectors from '@/redux/selectors/pieveSelectors/routeSelectors.js';
import * as runtimeSelectors from '@/redux/selectors/pieveSelectors/runtimeSelectors.js';
import * as activeThreadIdSelectors from '@/redux/selectors/pieveSelectors/activeThreadIdSelector.js';
import * as threadCoreSelectors from '@/redux/selectors/pieveSelectors/threadCoreSelectors.js';
import * as threadSubagentSelectors from '@/redux/selectors/pieveSelectors/threadSubagentSelectors.js';
import * as threadActivitySelectors from '@/redux/selectors/pieveSelectors/threadActivitySelectors.js';
import * as threadRunSelectors from '@/redux/selectors/pieveSelectors/threadRunSelectors.js';
import * as workflowStepTaskSelectors from '@/redux/selectors/pieveSelectors/workflowStepTaskSelectors.js';
import * as threadBlockerSelectors from '@/redux/selectors/pieveSelectors/threadBlockerSelectors.js';
import * as governanceSelectors from '@/redux/selectors/pieveSelectors/governanceSelectors.js';
import * as composerResolutionSelectors from '@/redux/selectors/pieveSelectors/composerResolutionSelectors.js';
import * as launcherComposerSelectors from '@/redux/selectors/pieveSelectors/launcherComposerSelectors.js';
import * as workflowVersionSelectors from '@/redux/selectors/pieveSelectors/workflowVersionSelectors.js';
import * as composerDraftSelectors from '@/redux/selectors/pieveSelectors/composerDraftSelectors.js';
import * as automationSharedSelectors from '@/redux/selectors/pieveSelectors/automationSharedSelectors.js';
import * as automationScheduleSelectors from '@/redux/selectors/pieveSelectors/automationScheduleSelectors.js';
import * as automationTriggerSelectors from '@/redux/selectors/pieveSelectors/automationTriggerSelectors.js';
import * as automationWorkflowSelectors from '@/redux/selectors/pieveSelectors/automationWorkflowSelectors.js';
import * as workflowRunSearchSelectors from '@/redux/selectors/pieveSelectors/workflowRunSearchSelectors.js';
import * as automationWorkflowRunLogsSelectors from '@/redux/selectors/pieveSelectors/automationWorkflowRunLogsSelectors.js';
import * as triggerActionSelectors from '@/redux/selectors/pieveSelectors/triggerActionSelectors.js';
import * as threadSurfaceSelectors from '@/redux/selectors/pieveSelectors/threadSurfaceSelectors.js';
import * as connectionSelectors from '@/redux/selectors/pieveSelectors/connectionSelectors.js';
import * as workflowActivitySelectors from '@/redux/selectors/pieveSelectors/workflowActivitySelectors.js';
import * as surfaceThreadSelectors from '@/redux/selectors/surfaces/threadSurfaceSelectors.js';
import * as settingsSelectors from '@/redux/selectors/settingsSelectors.js';
import * as onboardingSelectors from '@/redux/selectors/onboardingSelectors.js';

export const selectors = {
  ...uiSelectors,
  ...userSelectors,
  ...baseSelectors,
  ...sidebarChromeSelectors,
  ...sidebarSkillSelectors,
  ...sidebarProjectSelectors,
  ...sidebarThreadCollectionSelectors,
  ...sidebarOrganizationSelectors,
  ...sidebarSearchSelectors,
  ...routeSelectors,
  ...runtimeSelectors,
  ...activeThreadIdSelectors,
  ...threadCoreSelectors,
  ...threadSubagentSelectors,
  ...threadActivitySelectors,
  ...threadRunSelectors,
  ...workflowStepTaskSelectors,
  ...threadBlockerSelectors,
  ...governanceSelectors,
  ...composerResolutionSelectors,
  ...launcherComposerSelectors,
  ...workflowVersionSelectors,
  ...composerDraftSelectors,
  ...automationSharedSelectors,
  ...automationScheduleSelectors,
  ...automationTriggerSelectors,
  ...automationWorkflowSelectors,
  ...workflowRunSearchSelectors,
  ...automationWorkflowRunLogsSelectors,
  ...triggerActionSelectors,
  ...threadSurfaceSelectors,
  ...connectionSelectors,
  ...workflowActivitySelectors,
  ...surfaceThreadSelectors,
  ...settingsSelectors,
  ...onboardingSelectors
};

export default selectors;
